import { useApi } from "@lending/lib/api";

function useUpdateCreditCardApplicationQuery() {
  const $api = useApi();
  return $api.useMutation("patch", "/v2/lending/credit_card_applications/{uuid}/");
}

export { useUpdateCreditCardApplicationQuery };
